<template>
  <div>
    <el-table :data="tableData" style="width: 100%" border v-loading="loading">
      <el-table-column type="index" label="序号"> </el-table-column>
      <el-table-column prop="orderNo" label="订单">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleOrderDetail(scope.row)"
            >{{ scope.row.orderNo }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="orderIdentifier" label="渠道">
        <template slot-scope="scope">
          {{ scope.row.orderIdentifier | sysCodeFileter("order_identifier") }}
        </template>
      </el-table-column>
      <el-table-column prop="serviceType" label="工单类型">
        <template slot-scope="scope">
          {{ scope.row.serviceType | sysCodeFileter("order_type") }}
        </template>
      </el-table-column>
      <el-table-column prop="modelName" label="型号"> </el-table-column>
      <el-table-column prop="price" label="故障金额">
        <template slot-scope="scope">
          <span>¥{{ scope.row.price | 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payStatus" label="支付状态">
        <template slot-scope="scope">
          <span>{{ scope.row.payStatus | sysCodeFileter("pay_status") }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="adminStatus" label="工单状态">
        <template slot-scope="scope">
          <span>{{
            scope.row.adminStatus | sysCodeFileter("admin_status")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="下单时间"> </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    ></el-pagination>
  </div>
</template>
<script>
import { querySubscriberOrderPageApi } from "@/api/subscriber";
export default {
  name: "SubscriberOrder",
  props: {
    subscriberId: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      loading: false
    };
  },
  watch: {
    subscriberId: {
      immediate: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.subscriberId = val;
        this.loadPage(1);
      }
    }
  },
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      querySubscriberOrderPageApi(this.subscriberId, this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            this.tableData = res.data.results.list;
            this.searchForm.total = res.data.results.total;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.loadPage();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.loadPage();
    },
    handleOrderDetail(row) {
      this.$router.push({
        path: "/visitRepair",
        query: {
          orderId: row.id,
          orderNo: row.orderNo
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// subscriberOrder.vue?ee4b3a26